import { useContext, useEffect, useState } from "react";
import AuthContext from "../Context/AuthProvider";
import { getPrescription, viewPrescriptionById } from "../API/PrescriptionApi";
import { getServiceDetails } from "../API/LinkedServicesApi";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Card,
  Grid2,
  Tooltip,
  Typography,
  Chip,
  Divider,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useSnackbar } from "../Utility/UserMessageContext";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import { calculateAge, formatAge } from "../Utility/Utility";
import MenuBar from "../common/MenuBar";
import HeaderValueDisplay from "../common/HeaderValueDisplay";
import { convertUTCToTimeZoneDateTimeString } from "../Utility/DateTimeUtility";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";

function LaboratoryTestReportReadOnly({ serviceId, prescriptionId }) {
  const [errorMessage, setErrorMessage] = useState();
  const { auth } = useContext(AuthContext);
  const [reportStatus, setReportStatus] = useState();
  const [currentService, setCurrentService] = useState();
  const [labTechnician, setLabTechnician] = useState("");
  const [pathologist, setPathologist] = useState("");
  const [reportDate, setReportDate] = useState("");
  const [collectionDate, setCollectionDate] = useState("");
  const [sampleCollected, setSampleCollected] = useState("");
  const [patientId, setPatientId] = useState();
  const [referredBy, setReferredBy] = useState();
  const [reportStatusDisplay, setReportStatusDisplay] = useState();
  const [barcodeNo, setBarcodeNo] = useState();
  const [sampleType, setSampleType] = useState();
  const [sampleCollectionDateTime, setSampleCollectionDateTime] = useState("");
  const [sampleCollectionReportDate, setSampleCollectionReportDate] =
    useState("");
  const [sampleCollectionMethod, setSampleCollectionMethod] = useState("");
  const [sampleCollectionPerformedBy, setSampleCollectionPerformedBy] =
    useState("");
  const [sampleCollectionLocation, setSampleCollectionLocation] = useState("");

  const [additionalNotes, setAdditionalNotes] = useState("");
  const [status, setStatus] = useState("");
  const [labReportData, setLabReportData] = useState({ tests: [] });

  const { showSnackbar } = useSnackbar();
  const [referenceDialog, setReferenceDialog] = useState({
    open: false,
    title: "",
    text: "",
  });

  const [visitDisplayId, setVisitDisplayId] = useState("");
  const [patientName, setPatientName] = useState("");
  const [patientMRN, setPatientMRN] = useState("");
  const [patientGender, setPatientGender] = useState("");
  const [patientDateOfBirth, setPatientDateOfBirth] = useState("");

  const displayText = (value, fallback = "Not available") => {
    return value !== undefined && value !== null && value !== ""
      ? value
      : fallback;
  };

  const getResultStatus = (value, lowerLimit, upperLimit) => {
    if (!value || lowerLimit === undefined || upperLimit === undefined)
      return "normal";

    const numValue = parseFloat(value);
    if (isNaN(numValue)) return "normal";

    if (numValue < lowerLimit) return "low";
    if (numValue > upperLimit) return "high";
    return "normal";
  };

  const getStatusChipColor = (status) => {
    switch (status) {
      case "high":
        return "error";
      case "low":
        return "warning";
      case "normal":
        return "success";
      default:
        return "default";
    }
  };

  const handleReferenceClick = (testName, referenceText, event) => {
    event.stopPropagation();
    setReferenceDialog({
      open: true,
      title: testName,
      text: referenceText,
    });
  };

  const handleReferenceClose = () => {
    setReferenceDialog({
      open: false,
      title: "",
      text: "",
    });
  };

  useEffect(() => {
    // const loadService = async () => {
    //   if (auth != null && serviceId != null) {
    //     var result = await getServiceDetails(auth, serviceId);
    //     if (result?.isSuccess) {
    //       setCurrentService(result?.data);
    //     } else {
    //       showSnackbar(result?.data, "error");
    //     }
    //   }
    // };

    // In LaboratoryTestReportReadOnly.jsx, replace the useEffect loadPrescription function:

    const loadPrescription = async () => {
      if (auth != null && prescriptionId != null) {
        var result = await getPrescription(auth, prescriptionId);
        if (result.isSuccess) {
          var prescription = result?.data;
          setVisitDisplayId(prescription.visitDisplayId || "");
          setPatientName(prescription.patientName || "");
          setPatientMRN(prescription.patientMRN || "");
          setPatientGender(prescription.patientGender || "");
          setPatientDateOfBirth(prescription.patientDateOfBirth || "");
          setReportStatus(prescription?.status);

          if (prescription?.detailedPrescription) {
            var detailedReportJson = JSON.parse(
              prescription?.detailedPrescription
            );

            // Set the date fields from the correct source
            setSampleCollectionDateTime(
              detailedReportJson?.sampleCollectionDateTime ||
                prescription?.sampleCollectionDateTime ||
                ""
            );

            setSampleCollectionReportDate(
              detailedReportJson?.sampleCollectionReportDate ||
                prescription?.reportDate ||
                ""
            );

            // Set individual fields
            setLabTechnician(
              prescription?.labTechnician ||
                detailedReportJson?.labTechnician ||
                ""
            );
            setPathologist(
              prescription?.pathologist || detailedReportJson?.pathologist || ""
            );
            setReportDate(
              convertUTCToTimeZoneDateTimeString(
                prescription?.reportDate || detailedReportJson?.reportDate || ""
              )
            );
            setCollectionDate(
              convertUTCToTimeZoneDateTimeString(
                prescription?.sampleCollectionDateTime ||
                  detailedReportJson?.collectionDate ||
                  ""
              )
            );
            setSampleCollected(
              convertUTCToTimeZoneDateTimeString(
                prescription?.sampleCollectionDateTime ||
                  detailedReportJson?.sampleCollected ||
                  ""
              )
            );
            setSampleCollectionMethod(
              prescription?.sampleCollectionMethod ||
                detailedReportJson?.sampleCollectionMethod ||
                ""
            );
            setSampleCollectionPerformedBy(
              prescription?.sampleCollectionPerformedBy ||
                detailedReportJson?.sampleCollectionPerformedBy ||
                ""
            );
            setSampleCollectionLocation(
              prescription?.sampleCollectionLocation ||
                detailedReportJson?.sampleCollectionLocation ||
                ""
            );
            setPatientId(
              prescription?.patientId || detailedReportJson?.patientId
            );
            setReferredBy(
              prescription?.referredBy ||
                detailedReportJson?.referredBy ||
                "Self"
            );
            setReportStatusDisplay(
              prescription?.reportStatusDisplay ||
                detailedReportJson?.reportStatusDisplay
            );
            setBarcodeNo(
              prescription?.barcodeNo || detailedReportJson?.barcodeNo
            );
            setStatus(
              prescription?.status || detailedReportJson?.status || "Normal"
            );
            setSampleType(
              prescription?.sampleType || detailedReportJson?.sampleType
            );
            setAdditionalNotes(detailedReportJson?.additionalNotes || "");

            // Process tests data
            if (
              detailedReportJson?.tests &&
              detailedReportJson.tests.length > 0
            ) {
              // Filter tests to only show those with selected parameters or results
              const filteredTests = detailedReportJson.tests
                .map((test) => ({
                  ...test,
                  parameters: test.parameters
                    ? test.parameters.filter(
                        (param) =>
                          param.selected ||
                          param.resultValue ||
                          (param.notes && param.notes.trim() !== "")
                      )
                    : [],
                }))
                .filter((test) => test.parameters.length > 0);

              setLabReportData({
                ...detailedReportJson,
                tests: filteredTests,
              });
            } else {
              setLabReportData({ tests: [] });
            }
          }
        } else {
          showSnackbar(result?.data, "error");
        }
      }
    };

    //loadService();
    loadPrescription();
  }, [auth, serviceId, prescriptionId]);

  const viewPrescription = async () => {
    if (auth != null && prescriptionId != null) {
      await viewPrescriptionById(auth, prescriptionId);
    }
  };

  return (
    <>
      <Grid2 container size={12}>
        {/* <Grid2 container size={12}>
          <Grid2 size={12}>
            <MenuBar
              onDownload={viewPrescription}
              showDownload={reportStatus === "Final"}
              prescriptionStatus={reportStatus}
            />
          </Grid2>
        </Grid2> */}

        <Grid2 container size={12}>
          <Grid2
            size={{ sx: 12, sm: 12, md: 12, lg: 9, xl: 9 }}
            sx={{ paddingTop: "10px", padding: "10px", width: "100%" }}
          >
            <Card
              className="outerCard"
              variant="outlined"
              fullWidth
              sx={{ width: "100%", padding: "10px" }}
            >
              <Grid2
                container
                spacing={1}
                size={12}
                sx={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}
              >
                {/* Patient Information */}
                <Grid2 size={12}>
                  <Grid2 container size={12}>
                    <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                      <HeaderValueDisplay
                        header="Patient Name"
                        value={
                          patientName
                        }
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                      <HeaderValueDisplay
                        header="Age and Gender"
                        value={
                          calculateAge(patientDateOfBirth) +
                          " and " +
                          patientGender
                        }
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                      <HeaderValueDisplay
                        header="MRN"
                        value={patientMRN}
                      />
                    </Grid2>
                  </Grid2>
                  <Grid2 container size={12}>
                    <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                      <HeaderValueDisplay
                        header="Referred By"
                        value={displayText(referredBy, "Self")}
                      />
                    </Grid2>
                  </Grid2>
                  <Grid2 container size={12}></Grid2>
                </Grid2>
                {/* Report Details Section - ADD THIS */}
                <Grid2 size={12}>
                  <Card variant="outlined" sx={{ padding: "16px", mb: 2 }}>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: "bold", mb: 2 }}
                    >
                      Report Details
                    </Typography>
                    <Grid2 container spacing={2}>
                      <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                        <HeaderValueDisplay
                          header="Sample Collected"
                          value={
                            sampleCollectionDateTime
                              ? convertUTCToTimeZoneDateTimeString(
                                  sampleCollectionDateTime
                                )
                              : "Not available"
                          }
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                        <HeaderValueDisplay
                          header="Report Date"
                          value={
                            sampleCollectionReportDate
                              ? convertUTCToTimeZoneDateTimeString(
                                  sampleCollectionReportDate
                                )
                              : "Not available"
                          }
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                        <HeaderValueDisplay
                          header="Sample Type"
                          value={displayText(sampleType)}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                        <HeaderValueDisplay
                          header="Collection Method"
                          value={displayText(sampleCollectionMethod)}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                        <HeaderValueDisplay
                          header="Collected By"
                          value={displayText(sampleCollectionPerformedBy)}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                        <HeaderValueDisplay
                          header="Collection Location"
                          value={displayText(sampleCollectionLocation)}
                        />
                      </Grid2>
                    </Grid2>
                  </Card>
                </Grid2>

                {/* Test Results Section */}
                {labReportData.tests && labReportData.tests.length > 0 ? (
                  labReportData.tests.map((test, index) => {
                    // Only show tests that have at least one parameter with results
                    const hasResults = test.parameters.some(
                      (param) => param.resultValue || param.notes
                    );

                    if (!hasResults) return null;

                    return (
                      <Accordion
                        key={index}
                        defaultExpanded
                        variant="outlined"
                        sx={{ width: "100%", maxWidth: "100%" }}
                      >
                        <AccordionSummary
                          expandIcon={<GridExpandMoreIcon />}
                          sx={{
                            "& .MuiAccordionSummary-content": {
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            },
                          }}
                        >
                          <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: "bold" }}
                          >
                            {test.testName}
                          </Typography>
                          {test.referenceText && (
                            <IconButton
                              size="small"
                              onClick={(event) =>
                                handleReferenceClick(
                                  test.testName,
                                  test.referenceText,
                                  event
                                )
                              }
                              sx={{ marginLeft: "auto", marginRight: 1 }}
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          )}
                        </AccordionSummary>
                        <AccordionDetails
                          sx={{ padding: "8px", position: "relative" }}
                        >
                          <Grid2
                            container
                            spacing={3}
                            size={12}
                            sx={{ justifyContent: "center", paddingX: "10px" }}
                          >
                            <Grid2 size={12}>
                              <Table size="small">
                                <TableHead>
                                  <TableRow>
                                    <TableCell>
                                      <strong>Parameter Name</strong>
                                    </TableCell>
                                    <TableCell>
                                      <strong>Result Value</strong>
                                    </TableCell>
                                    <TableCell>
                                      <strong>Unit</strong>
                                    </TableCell>
                                    <TableCell>
                                      <strong>Normal Range</strong>
                                    </TableCell>
                                    <TableCell>
                                      <strong>Status</strong>
                                    </TableCell>
                                    <TableCell>
                                      <strong>Comments</strong>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {test.parameters.map(
                                    (parameter, parameterIndex) => {
                                      const status = getResultStatus(
                                        parameter.resultValue,
                                        parameter.lowerLimit,
                                        parameter.upperLimit
                                      );

                                      return (
                                        <TableRow key={parameterIndex}>
                                          <TableCell>
                                            {parameter.parameterName}
                                          </TableCell>
                                          <TableCell>
                                            <strong>
                                              {parameter.resultValue ||
                                                "Not recorded"}
                                            </strong>
                                          </TableCell>
                                          <TableCell>
                                            {parameter.unit}
                                          </TableCell>
                                          <TableCell>
                                            {parameter.lowerLimit} -{" "}
                                            {parameter.upperLimit}
                                          </TableCell>
                                          <TableCell>
                                            <Chip
                                              label={status.toUpperCase()}
                                              color={getStatusChipColor(status)}
                                              size="small"
                                            />
                                          </TableCell>
                                          <TableCell>
                                            {parameter.notes || "-"}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    }
                                  )}
                                </TableBody>
                              </Table>
                            </Grid2>
                          </Grid2>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })
                ) : (
                  <Grid2 size={12}>
                    <Card
                      variant="outlined"
                      sx={{ padding: "20px", textAlign: "center" }}
                    >
                      <Typography variant="body1" color="textSecondary">
                        No test results available to display.
                      </Typography>
                    </Card>
                  </Grid2>
                )}

                {/* Additional Notes Section */}
                <Accordion
                  defaultExpanded
                  variant="outlined"
                  sx={{ width: "100%", maxWidth: "100%" }}
                >
                  <AccordionSummary
                    expandIcon={<GridExpandMoreIcon />}
                    aria-controls="panel-notes-content"
                    id="panel-notes-header"
                  >
                    <Typography component="span">
                      Additional Notes & Summary
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{ padding: "8px", position: "relative" }}
                  >
                    <Grid2
                      container
                      spacing={3}
                      size={12}
                      sx={{ justifyContent: "center", paddingX: "10px" }}
                    >
                      <Grid2 size={12}>
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "bold", mb: 1 }}
                        >
                          Additional Notes
                        </Typography>
                        <Typography variant="body1" paragraph>
                          {additionalNotes || "No additional notes provided."}
                        </Typography>
                      </Grid2>

                      <Grid2 size={12}>
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "bold", mb: 1 }}
                        >
                          Abnormal Results Summary
                        </Typography>
                        <Box>
                          {(() => {
                            const abnormalResults = [];
                            labReportData.tests.forEach((test) => {
                              test.parameters.forEach((parameter) => {
                                const status = getResultStatus(
                                  parameter.resultValue,
                                  parameter.lowerLimit,
                                  parameter.upperLimit
                                );

                                if (
                                  status !== "normal" &&
                                  parameter.resultValue
                                ) {
                                  abnormalResults.push({
                                    testName: parameter.parameterName,
                                    value: parameter.resultValue,
                                    unit: parameter.unit,
                                    status: status,
                                    normalRange: `${parameter.lowerLimit} - ${parameter.upperLimit}`,
                                    notes: parameter.notes,
                                  });
                                }
                              });
                            });

                            return abnormalResults.length > 0 ? (
                              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                {abnormalResults.map((result, index) => (
                                  <li
                                    key={index}
                                    style={{ marginBottom: "8px" }}
                                  >
                                    <Typography variant="body2">
                                      <strong>{result.testName}</strong>:{" "}
                                      {result.value} {result.unit}
                                      <Chip
                                        label={result.status.toUpperCase()}
                                        color={getStatusChipColor(
                                          result.status
                                        )}
                                        size="small"
                                        sx={{ ml: 1, mr: 1 }}
                                      />
                                      (Normal: {result.normalRange})
                                      {result.notes && (
                                        <Typography
                                          variant="body2"
                                          color="textSecondary"
                                          sx={{
                                            ml: 2,
                                            fontStyle: "italic",
                                            mt: 0.5,
                                          }}
                                        >
                                          Note: {result.notes}
                                        </Typography>
                                      )}
                                    </Typography>
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <Typography variant="body2" color="textSecondary">
                                No abnormal results found.
                              </Typography>
                            );
                          })()}
                        </Box>
                      </Grid2>
                    </Grid2>
                  </AccordionDetails>
                </Accordion>
              </Grid2>
            </Card>
          </Grid2>
        </Grid2>
      </Grid2>

      {/* Reference Dialog */}
      <Dialog
        open={referenceDialog.open}
        onClose={handleReferenceClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Reference Text - {referenceDialog.title}</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
            {referenceDialog.text ||
              "No reference text available for this test."}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReferenceClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default LaboratoryTestReportReadOnly;
